import { BerechnungsgrundlageDreiMonatsdurchschnitt } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/berechnungsgrundlageDreiMonatsDurchschnitt';
import { Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt } from '@/gql/graphql';

export function mapBerechnungsgrundlageDreiMonatsDurchschnitt(
  berechnungsgrundlage: BerechnungsgrundlageDreiMonatsdurchschnitt,
): Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt {
  switch (berechnungsgrundlage) {
    case 'moegliche_arbeitstage':
      return Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt.Arbeitstage;

    case 'anzahl_sv_tage':
      return Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt.Sozialversicherungstage;

    default:
      berechnungsgrundlage satisfies never;
      throw new Error(
        `Unexpected value for Berechnungsgrundlage ${berechnungsgrundlage}`,
      );
  }
}
